import NavBar from '../features/navbar/Navbar';
import UserOrders from '../features/user/components/UserOrders';
import MainLayout from '../components/MainLayout';

function UserOrdersPage() {
  return (
    <MainLayout>
      <NavBar>
        <UserOrders></UserOrders>
      </NavBar>
    </MainLayout>
  );
}

export default UserOrdersPage;
